import type { MyOrganization, PartyKind } from "@shyne/shared/api";
import { organization_type, type MemberOrganization } from "@/models/organization.model";
import { organization_user_status } from "@/models/organization-user.model";

const TYPE_OF_KIND: Record<PartyKind, organization_type> = {
  vendor: organization_type.vendor,
  customer: organization_type.pmc,
  subcontractor: organization_type.subs,
  worker: organization_type.emp,
};

export const organizationTypeOfKind = (kind: PartyKind): organization_type => TYPE_OF_KIND[kind];

const STATUS: Record<MyOrganization["status"], organization_user_status> = {
  active: organization_user_status.active,
  suspended: organization_user_status.suspended,
  pending: organization_user_status.pending,
  invited: organization_user_status.invited,
};

export const toUserStatus = (status: MyOrganization["status"]): organization_user_status => STATUS[status];

export const toMemberOrganization = (organization: MyOrganization): MemberOrganization => ({
  id: organization.id,
  display_name: organization.name,
  type: TYPE_OF_KIND[organization.kind],
  image: organization.logo,
  role: organization.role,
  status: toUserStatus(organization.status),
});
